var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5261 2.13158C17.5261 2.7856 16.9959 3.31579 16.3419 3.31579L6.39455 3.3158C5.74053 3.3158 5.21034 2.78561 5.21034 2.13158C5.21034 1.47756 5.74053 0.947374 6.39455 0.947374L16.3419 0.947373C16.9959 0.947373 17.5261 1.47756 17.5261 2.13158Z",
    fill: "#9296AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31567 2.13158C3.31567 2.78561 2.78548 3.3158 2.13146 3.3158C1.47744 3.3158 0.947253 2.78561 0.947253 2.13159C0.947253 1.47756 1.47744 0.947375 2.13146 0.947375C2.78548 0.947375 3.31567 1.47756 3.31567 2.13158Z",
    fill: "#9296AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5261 6.8684C17.5261 7.52242 16.9959 8.05261 16.3419 8.05261L6.39455 8.05261C5.74053 8.05261 5.21034 7.52242 5.21034 6.8684C5.21034 6.21438 5.74053 5.68419 6.39455 5.68419L16.3419 5.68419C16.9959 5.68419 17.5261 6.21438 17.5261 6.8684Z",
    fill: "#9296AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31567 6.86852C3.31567 7.52254 2.78548 8.05273 2.13146 8.05273C1.47744 8.05273 0.947253 7.52255 0.947253 6.86852C0.947253 6.2145 1.47744 5.68431 2.13146 5.68431C2.78548 5.68431 3.31567 6.2145 3.31567 6.86852Z",
    fill: "#9296AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5261 11.6053C17.5261 12.2594 16.9959 12.7895 16.3419 12.7895L6.39455 12.7896C5.74053 12.7896 5.21034 12.2594 5.21034 11.6053C5.21034 10.9513 5.74053 10.4211 6.39455 10.4211L16.3419 10.4211C16.9959 10.4211 17.5261 10.9513 17.5261 11.6053Z",
    fill: "#9296AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31567 11.6053C3.31567 12.2594 2.78548 12.7896 2.13146 12.7896C1.47744 12.7895 0.947253 12.2594 0.947253 11.6053C0.947253 10.9513 1.47744 10.4211 2.13146 10.4211C2.78548 10.4211 3.31567 10.9513 3.31567 11.6053Z",
    fill: "#9296AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5261 16.3422C17.5261 16.9962 16.9959 17.5264 16.3419 17.5264L6.39455 17.5264C5.74053 17.5264 5.21034 16.9962 5.21034 16.3422C5.21034 15.6881 5.74053 15.1579 6.39455 15.1579L16.3419 15.1579C16.9959 15.1579 17.5261 15.6881 17.5261 16.3422Z",
    fill: "#9296AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31567 16.3422C3.31567 16.9962 2.78548 17.5264 2.13146 17.5264C1.47744 17.5264 0.947253 16.9962 0.947253 16.3422C0.947253 15.6881 1.47744 15.1579 2.13146 15.1579C2.78548 15.1579 3.31567 15.6881 3.31567 16.3422Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListGray);
export default __webpack_public_path__ + "static/media/listGray.968e09ea44ef1b30d9cce64eea50a52b.svg";
export { ForwardRef as ReactComponent };